import axios from "axios";
import { Dispatch } from "redux";
import {
    PMS_CONNECT_FAILURE,
    PMS_CONNECT_REQUEST,
    PMS_CONNECT_SUCCESS,
} from "../constants/pms-connect.constant";

/** Payload for Yardi connect-pms API (flat keys as expected by backend) */
export interface ConnectPmsYardiPayload {
    yardiPropertyId: string;
    yardiUserName: string;
    yardiPassword: string;
    yardiServerName: string;
    yardiTransactionSource: string;
    yardiBaseUrl: string;
    yardiAgentFirstName: string;
    yardiAgentLastName: string;
}

export interface ConnectPmsEntrataPayload {
    entrataUserName: string;
    entrataPassword: string;
    entrataPropertyId: string;
    entrataSubDomainName: string;
    entrataUrl: string;
    originationSourceId: string;
}

export interface ConnectPmsRealpagePayload {
    buildingId: string;
    pineappleLeasingAgentID: string;
    realPageILMPropertyId: string;
    realPageL2LPropertyId: string;
    realPagePmcID: string;
    realPageSiteID: string;
    realpageMarketingSourceId: string;
}

export interface ConnectPmsResmanPayload {
    resmanAccountId: string;
    resmanPropertyId: string;
    resmanAgentId: string;
    resmanTransactionSource: string;
}

export interface ConnectPmsKnockPayload {
    knockCommunityId: string;
    knockAgentUserName: string;
    knockSourceTitle: string;
    knockCompanyId: string;
    knockPropertyId: string;
}

export interface ConnectPmsFunnelPayload {
    funnelCommunityId: string;
}

export type ConnectPmsPayload = ConnectPmsYardiPayload | ConnectPmsEntrataPayload | ConnectPmsRealpagePayload | ConnectPmsResmanPayload | ConnectPmsKnockPayload | ConnectPmsFunnelPayload;

export const connectPms = (pmsKey: string, payload: ConnectPmsPayload, locationId: string) => {
    return (dispatch: Dispatch) => {
        dispatch({ type: PMS_CONNECT_REQUEST });
        return axios
            .post(`/propify/connect-pms?pms_key=${pmsKey}&locationId=${locationId}`, payload)
            .then((response) => {
                const statusCode = response?.data?.statusCode ?? response?.status;
                const message = response?.data?.message || "Connection failed";
                if (statusCode === 200 || statusCode === 201) {
                    dispatch({
                        type: PMS_CONNECT_SUCCESS,
                        payload: response.data,
                    });
                    return response.data;
                }
                dispatch({ type: PMS_CONNECT_FAILURE, payload: message });
                return Promise.reject(new Error(message));
            })
            .catch((error) => {
                const message =
                    error?.response?.data?.message ||
                    error?.message ||
                    "Something went wrong";
                dispatch({ type: PMS_CONNECT_FAILURE, payload: message });
                return Promise.reject(new Error(message));
            });
    };
};
